<div class="d-flex align-items-center" mat-dialog-title>
    <div class="spacer title">Materieel {{ planning.worknumber ?? planning.afas_project_id }}</div>
    <div>
        <button mat-dialog-close mat-icon-button tabindex="-1"><i class="fas fa-times"></i></button>
    </div>
</div>
@if (entitiesMap && entities) {
    <div class="flex-fill" mat-dialog-content>
        <div class="row">
            <div class="col-lg-16 col-md-18 col-xl-18">
                <h3>Details</h3>
                <table class="table table-last-col table-hover">
                    <tr>
                        <th>Type</th>
                        <th>Materieel</th>
                        <th style="width: 115px; min-width: 115px">Van</th>
                        <th style="width: 65px; min-width: 65px">Tot</th>
                        <th>Opmerking</th>
                        <th></th>
                    </tr>
                    @for (formgroup of form.controls; track formgroup) {
                        <tr [formGroup]="formgroup">
                            <td>
                                {{ entityTypeMap.get(formgroup.controls.entitytype_key.value)?.name }}
                            </td>
                            <td>
                                {{ entitiesMap.get(formgroup.controls.entity_id.value)?.name }}
                            </td>
                            <td class="datetime-input" matTooltip="{{ formgroup.controls.conflictText.value }}">
                                <app-datetime-input
                                    [formControl]="formgroup.controls.begindate"
                                    labelDate="start"
                                    labelTime="tijd"></app-datetime-input>
                            </td>
                            <td class="datetime-input">
                                <app-datetime-input
                                    [formControl]="formgroup.controls.enddate"
                                    [hideDate]="true"
                                    labelDate="eind"
                                    labelTime="tijd"></app-datetime-input>
                            </td>
                            <td class="textarea-input">
                                <textarea
                                    [formControl]="formgroup.controls.comment"
                                    [cdkAutosizeMaxRows]="5"
                                    matInput
                                    cdkTextareaAutosize
                                    placeholder="Omschrijving"
                                    rows="1"></textarea>
                            </td>
                            <td>
                                <button class="delete-button" (click)="delete(formgroup)" color="warn" mat-icon-button>
                                    <mat-icon class="fas fa-trash"></mat-icon>
                                </button>
                            </td>
                        </tr>
                    }
                </table>
                <h3>Materieel inplannen</h3>
                <div class="row">
                    <div class="col">
                        <div class="pr-5">
                            <ng-select
                                [formControl]="fcEntity"
                                [clearable]="true"
                                (change)="addEquipment(+this.fcEntity.value)"
                                appearance="outline"
                                name="employee-filter"
                                placeholder="Kies materieel"
                                appendTo="body"
                                tabIndex="-1">
                                @for (entity of filteredEntities; track entity) {
                                    <ng-option [value]="entity.id">
                                        {{ entity.name }}
                                        (
                                        @for (t of entity.entitytypes; track t) {
                                            {{ t.name }}
                                        }
                                        )
                                    </ng-option>
                                }
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-8 col-md-6 col-xl-6">
                <h3>Overzicht</h3>
                <table class="table">
                    <tr>
                        <th>Functie</th>
                        <th>Aantal</th>
                    </tr>
                    @for (sum of sums; track sum) {
                        <tr>
                            <td>
                                {{ entityTypeMap.get(sum.entitytypeKey)?.plural_name }}
                            </td>
                            <td>
                                {{ sum.amount }}
                            </td>
                        </tr>
                    }
                </table>
                <b>Projectnummer:</b> {{ planning.worknumber ?? planning.afas_project_id }}<br />
                <b>Locatie:</b> {{ planning.location }}<br />
                <b>Omschrijving:</b> {{ planning.description }}
            </div>
        </div>
    </div>
}
<div class="d-flex flex-wrap pt-2 pb-2 justify-content-between" mat-dialog-actions>
    <button class="me-2" id="close-empl" (click)="close()" color="secondary" mat-raised-button>Sluiten</button>
    <button [disabled]="saving" (click)="save()" color="primary" mat-raised-button>
        Opslaan
        @if (saving) {
            <i class="fas fa-circle-notch fa-spin"></i>
        }
    </button>
</div>
